/**
 * SiteLayout.tsx — site shell layout
 *
 * Purpose:    Header + main + footer wrapper for all nsentry pages
 * Inputs:     child routes via <Outlet />
 * Outputs:    Rendered page with site chrome
 * Constraints: No SSR; shared across all routes
 * SOT:        T-P3-E3-W2-S5-T01
 */
import { Outlet } from 'react-router-dom'
import { SiteHeader } from '../components/SiteHeader'
import { SiteFooter } from '../components/SiteFooter'

export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-bg text-brand-ink antialiased">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[9999] focus:rounded-md focus:bg-sky-500 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white"
      >
        Skip to main content
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
